import { setActiveSwitcherRezaForAxios } from '@gov-nx/api';
import type { RezaSwitcherStoreState } from './store.types';
import { createScopedStoreHook } from '../createScopedStoreHook';

const initialState = {
	activeSwitcherReza: null,
};

export const useRezaSwitcherStore =
	createScopedStoreHook<RezaSwitcherStoreState>(
		(set) => ({
			...initialState,
			setActiveSwitcherReza: (activeSwitcherReza) =>
				set({ activeSwitcherReza }),
			resetActiveSwitcherReza: () => set(initialState),
		}),
		{
			onSubscribe: (state) => {
				setActiveSwitcherRezaForAxios(state.activeSwitcherReza);
			},
			onUnmount: (state) => {
				state.resetActiveSwitcherReza();
			},
		}
	);
